// The bridge between services/api.js and the ReasonPrompt dialog (components/ReasonPrompt.js): when the server answers 428
// REASON_REQUIRED (a sales user asking to modify or delete something), api.js calls askReason and sends the request again
// with the reason. Resolves the reason, or null if the person cancelled.
let handler = null;

export const registerReasonPrompt = (fn) => { handler = fn; return () => { if (handler === fn) handler = null; }; };

export const askReason = (ask) => (handler ? handler(ask) : Promise.resolve(null));
